<template>
  <app-ag-grid
    title="Renewal Payments"
    :columnDefs="columnDefs"
    :rowData="renewalPayments"
    :loading="loading"
    :getRowStyle="getRowStyle"
    :mobileCard="mobileCard"
    :newBtn="false"
    @refresh="fetchRenewalPayments"
    @row-dbl-click="(data) => $router.push({ path: `renewal-payments/${data._id}/view` })"
  ></app-ag-grid>
</template>

<script>
import AppAgGrid from "@/components/common/ag-grid.vue";

const STATUS_STYLES = {
  verified: { background: "#e6f4ea", color: "#1e7e34" },
  created: { background: "#eef3fb", color: "#0a5a90" },
  paid: { background: "#eef3fb", color: "#0a5a90" },
  failed: { background: "#fdecea", color: "#c62828" },
};

export default {
  name: "RenewalPaymentsPage",
  components: { AppAgGrid },

  data() {
    return {
      loading: false,

      columnDefs: [
        {
          headerName: "View",
          field: "_id",
          width: 80,
          cellRenderer: (params) => {
            return `
              <i
                class="mdi mdi-eye view-renewal-payment"
                data-id="${params.data._id}"
                title="View Renewal Payment"
                style="
                  cursor: pointer;
                  font-size: 18px;
                  color: #0a5a90;
                "
              ></i>
            `;
          },

          onCellClicked: (params) => {
            if (params.event.target.classList.contains("view-renewal-payment")) {
              this.$router.push({ path: `renewal-payments/${params.data._id}/view` });
            }
          },
        },
        {
          headerName: "Name",
          field: "userId.name",
          valueGetter: (p) => p.data?.userId?.name || "-",
        },
        {
          headerName: "Email",
          field: "userId.email",
          width: 260,
          valueGetter: (p) => p.data?.userId?.email || "-",
        },
        {
          headerName: "Amount",
          field: "amount",
          valueFormatter: (p) => {
            if (p.value == null) return "-";
            return `₹${(p.value / 100).toLocaleString("en-IN", {
              minimumFractionDigits: 2,
            })}`;
          },
        },
        { headerName: "Currency", field: "currency", width: 110 },
        {
          headerName: "Status",
          field: "status",
          cellStyle: (params) => {
            const style = STATUS_STYLES[params.value];
            return style ? { ...style, fontWeight: "600" } : null;
          },
        },
        { headerName: "Order ID", field: "razorpayOrderId", width: 220 },
        { headerName: "Payment ID", field: "razorpayPaymentId", width: 220 },
        {
          headerName: "Verification",
          field: "verificationSource",
          valueFormatter: (p) => p.value || "-",
        },
        {
          headerName: "Previous Expiry",
          field: "previousExpiryDate",
          valueFormatter: (p) => this.formatDate(p.value),
        },
        {
          headerName: "New Expiry",
          field: "newExpiryDate",
          valueFormatter: (p) => this.formatDate(p.value),
        },
        {
          headerName: "Paid On",
          field: "createdAt",
          valueFormatter: (p) => this.formatDate(p.value),
        },
      ],
    };
  },

  computed: {
    renewalPayments() {
      return this.$store.state.renewalPayments.renewalPayments;
    },

    mobileCard() {
      return {
        title: (row) => row.userId?.name || "-",
        subtitle: (row) => row.userId?.email || "-",
        badge: (row) => ({
          text: row.status || "-",
          style: STATUS_STYLES[row.status] || { background: "#eef3fb", color: "#0a5a90" },
        }),
        fields: (row) => [
          {
            label: "Amount",
            value:
              row.amount != null
                ? `₹${(row.amount / 100).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
                : "-",
          },
          { label: "New Expiry", value: this.formatDate(row.newExpiryDate) },
          { label: "Paid On", value: this.formatDate(row.createdAt) },
        ],
        actions: (row) => [
          {
            label: "View",
            icon: "mdi-eye-outline",
            color: "#0a5a90",
            onClick: () =>
              this.$router.push({ path: `renewal-payments/${row._id}/view` }),
          },
        ],
      };
    },
  },

  created() {
    this.fetchRenewalPayments();
  },

  methods: {
    async fetchRenewalPayments() {
      this.loading = true;
      try {
        await this.$store.dispatch("renewalPayments/getRenewalPayments");
      } finally {
        this.loading = false;
      }
    },

    formatDate(value) {
      if (!value) return "-";
      const date = new Date(value);
      if (isNaN(date.getTime())) return "-";
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    },

    getRowStyle(params) {
      if (params.data && params.data.status === "failed") {
        return { backgroundColor: "#fdecea" };
      }
      return null;
    },
  },
};
</script>
